"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _storybook = require("@pikassa/storybook");

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function LegalInfo(_ref) {
  var merchant = _ref.merchant,
      inProcess = _ref.inProcess,
      onUpdateLegal = _ref.onUpdateLegal;
  var isLegal = merchant.type === 'LEGAL';
  var isST = merchant.type === 'ST';
  var isModerated = merchant.status.type === 'Moderated';
  var tin = '';

  if (isLegal) {
    var _merchant$profile$leg;

    tin = (_merchant$profile$leg = merchant.profile.legalData.legal.tin) !== null && _merchant$profile$leg !== void 0 ? _merchant$profile$leg : '';
  } else if (isST) {
    var _merchant$profile$sol;

    tin = (_merchant$profile$sol = merchant.profile.soleTraderData.soleTrader.tin) !== null && _merchant$profile$sol !== void 0 ? _merchant$profile$sol : '';
  }

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      incorrectData = _useState2[0],
      setIncorrectData = _useState2[1];

  var _useState3 = (0, _react.useState)(tin),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      tinValue = _useState4[0],
      setTinValue = _useState4[1];

  var _useState5 = (0, _react.useState)(tin),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      oldTinValue = _useState6[0],
      setOldTinValue = _useState6[1];

  (0, _react.useEffect)(function () {
    validate();
  });

  function validate() {
    if ((/^([0-9]{10})$/.test('' + tinValue) && isLegal || /^([0-9]{12})$/.test('' + tinValue) && isST) && oldTinValue !== tinValue) {
      setIncorrectData(false);
    } else {
      setIncorrectData(true);
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    var data = (0, _cloneDeep["default"])(merchant);
    delete data.name;

    if (isLegal) {
      data.profile.legalData.legal.tin = tinValue;
    } else if (isST) {
      data.profile.soleTraderData.soleTrader.tin = tinValue;
    }

    onUpdateLegal && onUpdateLegal(data);
    setOldTinValue(tinValue);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['block'],
    "data-locator": "options.legal"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['block__title']
  }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
    type: 'section'
  }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u043E \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438")), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['block__content']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['block__field-title'],
    "data-locator": "options.legal.title"
  }, "\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['field']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['field__label'],
    "data-locator": "options.legal.field.title"
  }, "\u0418\u041D\u041D \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438"), /*#__PURE__*/_react["default"].createElement("form", {
    className: _defaultModule["default"]['field__content'],
    onSubmit: function onSubmit(e) {
      return handleSubmit(e);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['input-container']
  }, /*#__PURE__*/_react["default"].createElement(_storybook.Input, {
    value: tinValue,
    disabled: inProcess || isModerated,
    "data-locator": 'options.legal.field.input',
    onChange: function onChange(e) {
      return setTinValue(e.target.value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
    type: 'submit',
    mode: 'success',
    inProcess: inProcess,
    "data-locator": 'options.legal.submit',
    disabled: inProcess || incorrectData
  }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")))));
}

var _default = LegalInfo;
exports["default"] = _default;